import type { Price } from "mws-ts-v2-sdk";

export const isPriceInCurrencyNotAvailable = (
  price: Price[],
  currency: string,
) => typeof price.find((p) => p.currency === currency)?.price !== "number";

export const getPriceInCurrency = (price: Price[], currency: string) =>
  price.find((p) => p.currency === currency)?.price || 0;
